export default {
  env: 'local' as const,
  checkout: 'pk_test_49fb5cae-b3b1-40fd-bea6-e951f2492b20',
  hostname: 'https://local.dev.marshmallow.co',
  appUrl: 'http://localhost:3000',
  pcaapikey: 'EY51-AW78-UM56-NZ87',
  segmentkey: 'gNFRmf1e5XEODW9GS7aOSi3Xdm0mrbQc',
  intercomKey: 'jh4vt8fe',
  ravelinKey: 'publishable_key_test_4ArUnX6Gw1LzbU4J1ioE3qNrAUcUfOle',
  ravelinCookieDomain: 'localhost',
  logging: false,
  confusedTrackingUrl: 'https://avatars1.githubusercontent.com/u/5640930?s=88&v=4',
  customerAccount: 'https://customer-portal.local.dev.marshmallow.co', // Redirect to staging if running locally
  plaidEnv: 'sandbox',
  plaidPublicKey: 'c972a242afdd539c5c38d6b35feb1f',
  plaidWebhook: 'https://local.dev.marshmallow.co/open-banking/updates',
  timeout: 45000,
  rollouts: '7sX4s98p1ob5ZVDRzP8Yw',
  datadog: null,
  sentry: null,
}
